import * as types from '../Types/TenantTypes';
import { getHeader } from '../ConfigureStore';

export function setClientAssets(assets) {
  return {
    type: types.SET_CLIENT_ASSETS,
    payload: assets
  };
}

export function initializeTenantConfig(tenantCode) {
  return {
    types: [
      types.FETCH_TENANT_CONFIG,
      types.FETCH_TENANT_CONFIG_SUCCESS,
      types.FETCH_TENANT_CONFIG_FAILURE
    ],
    payload: {
      tenantCode
    },
    promise: client => client.get(`/tenant-config/${tenantCode}`, getHeader())
  };
}
